@if (incomeTaxEntity$ | async) {
  @if (heeftWuo) {
    <form [formGroup]="formGroup">
      <snelstart-ui-number-form-control
        [decimals]="0"
        align="right"
        class="custom-input-250"
        formControlName="loonAlsOnderdeelVanWinst"
        id="loonAlsOnderdeelVanWinst"
        label="Bedrag brutoloon"
        prefix="€"
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-number-form-control
        [decimals]="0"
        align="right"
        class="custom-input-250"
        formControlName="loonheffingOverLoonAlsOnderdeelVanWinst"
        id="loonheffingOverLoonAlsOnderdeelVanWinst"
        label="Ingehouden loonheffing"
        prefix="€"
      >
      </snelstart-ui-number-form-control>
    </form>
  } @else {
    Er zijn geen ondernemingen gevonden in de aangifte.
  }
}
